@if (!isLoading()) {
  @if (isRequestHeaderUiEnhancementEnabled()) {
    <div
      class="request-page h-full flex flex-col gap-md no-padding-page-container bg-neutral-50">
      <div class="flex justify-between gap-xl flex-1 min-h-0 overflow-hidden">
        <div class="h-full min-h-0 flex flex-col w-full gap-xl overflow-hidden">
          <div class="header shrink-0 bg-white p-2xl rounded-lg">
            <div class="pb-md">
              <lib-request-details-header
                [requestDetailsResponse]="requestDetailsResponse()"
                [showRequestId]="true"
                [showTrigger]="false"
                [showCategory]="true"
                [showDescription]="false"
                [showStatus]="true"
                [showCollaboratorsSection]="showCollaboratorsSection()"
                [requestType]="requestType()"
                [assignedList]="collaborators()"
                [rawCollaborators]="rawCollaborators()"
                [assignedListCurrentPage]="collaboratorsCurrentPage()"
                [assignedListTotalPages]="totalCollaboratorsPages()"
                [assignedListTotal]="totalCollaboratorsItems()"
                [isAssignedListLoading]="isLoadingCollaborators()"
                (getAssignedCardList)="getAssignedCardList($event)" />
            </div>

            <div class="border border-neutral-200 rounded-xl mt-md mb-md">
              @if (!isStepperCollapsed()) {
                <div class="flex items-center gap-md px-xl py-xl">
                  <div class="flex-1 min-w-0">
                    <lib-stepper
                      [stepperId]="'request-view-stepper'"
                      [options]="stepperOption()"
                      [isCentered]="false"
                      [assigneeTemplate]="assigneeTemplate" />
                  </div>

                  <button
                    type="button"
                    class="shrink-0 flex items-center gap-sm text-sm font-medium text-primary-500 bg-transparent border-none cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap"
                    (click)="isStepperCollapsed.set(true)">
                    {{ 'request_screen_collapse_steps_button' | transloco }}
                    <lib-chevron-down-icon
                      [iconClass]="'size-4 text-primary-500 rotate-180'" />
                  </button>
                </div>
              } @else {
                <div class="flex items-center justify-between px-xl py-md">
                  <div class="flex items-center gap-md">
                    @if (
                      requestDetailsResponse().data.current_position !==
                      undefined
                    ) {
                      <span
                        class="inline-flex items-center justify-center rounded-full text-xs font-semibold text-neutral-700 bg-neutral-100 px-sm">
                        {{ requestDetailsResponse().data.current_position! }}/{{
                          stepperOption().length
                        }}
                      </span>
                      <span class="text-sm font-medium text-neutral-900">
                        {{
                          stepperOption()[
                            requestDetailsResponse().data.current_position! - 1
                          ]?.label
                        }}
                      </span>
                    }
                  </div>
                  <button
                    type="button"
                    class="flex items-center gap-sm text-sm font-medium text-primary-500 bg-transparent border-none cursor-pointer hover:text-primary-600 transition-colors"
                    (click)="isStepperCollapsed.set(false)">
                    {{ 'request_screen_expand_steps_button' | transloco }}
                    <lib-chevron-down-icon
                      [iconClass]="'size-4 text-primary-500'" />
                  </button>
                </div>
              }
            </div>
          </div>

          <div class="form flex-1 min-h-0 flex justify-between gap-xl">
            <div
              class="bg-white p-2xl rounded-lg w-full overflow-y-auto flex flex-col gap-xl">
              @if (showHoldAlert()) {
                <lib-alert-inline
                  [hasCloseIcon]="false"
                  [hasContent]="true"
                  [hasIcon]="true"
                  [alertClass]="'border-warning-200 m-0!'"
                  [alertData]="holdAlertData()" />
              }

              <lib-form-builder
                [group]="requestFormGroups()"
                [form]="requestForm" />

              @if (holdResumeAction().value) {
                <div
                  class="shrink-0 flex gap-xl bg-white justify-end rounded-lg border-t border-neutral-200 pt-xl">
                  <lib-button
                    id="request_screen_cancel_button'"
                    [label]="'request_screen_cancel_button' | transloco"
                    (click)="cancel()"
                    [btnClass]="'px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium border border-neutral-300'" />

                  <lib-button
                    [id]="holdResumeAction().value"
                    [label]="holdResumeAction().label"
                    (click)="handleTakenAction(holdResumeAction().value)"
                    [disabled]="isDisabled()"
                    [btnClass]="
                      'px-2xl py-sm rounded-md text-lg font-medium ' +
                      (holdResumeAction().color | actionClass)
                    " />
                </div>
              }
            </div>
          </div>
        </div>

        <div
          class="bg-white h-full min-h-0 overflow-auto rounded-lg"
          [class.w-1/2]="showSideDetails()">
          <lib-request-view-actions
            [showUnreadMessagesIndicator]="showUnreadMessagesIndicator()"
            [showSideDetails]="showSideDetails()"
            [offCanvasRequestDetailsResponse]="requestDetailsResponse()"
            [flowId]="flowId()"
            [newComment]="newComment()"
            [deletedCommentId]="deletedCommentId()"
            [activeTabIndex]="activeTabIndex()"
            [showContributorsTab]="showContributorsTab()"
            (openDetailsSidebar)="openDetailsSidebar()"
            (closeDetailsSidebar)="closeDetailsSidebar()"
            (tabChanged)="onTabChanged($event)" />
        </div>
      </div>
    </div>
  } @else {
    <div class="flex flex-col">
      <lib-request-details-header
        [requestDetailsResponse]="requestDetailsResponse()"
        [showRequestId]="true"
        [showTrigger]="false"
        [showCategory]="true"
        [showDescription]="false"
        [showStatus]="true"
        [showCollaboratorsSection]="showCollaboratorsSection()"
        [requestType]="requestType()"
        [assignedList]="collaborators()"
        [rawCollaborators]="rawCollaborators()"
        [assignedListCurrentPage]="collaboratorsCurrentPage()"
        [assignedListTotalPages]="totalCollaboratorsPages()"
        [assignedListTotal]="totalCollaboratorsItems()"
        [isAssignedListLoading]="isLoadingCollaborators()"
        (getAssignedCardList)="getAssignedCardList($event)" />

      @if (showHoldAlert()) {
        <lib-alert-inline
          [hasCloseIcon]="false"
          [hasContent]="true"
          [hasIcon]="true"
          [alertClass]="'border-warning-200'"
          [alertData]="holdAlertData()" />
      }

      <div class="mb-xl flex justify-between mt-2xl">
        <h4 class="font-semibold text-lg text-neutral-900">
          {{ 'request_screen_stepper_title' | transloco }}
        </h4>

        <lib-request-view-actions
          [showUnreadMessagesIndicator]="showUnreadMessagesIndicator()"
          [showSideDetails]="showSideDetails()"
          [offCanvasRequestDetailsResponse]="requestDetailsResponse()"
          [flowId]="flowId()"
          [newComment]="newComment()"
          [deletedCommentId]="deletedCommentId()"
          [activeTabIndex]="activeTabIndex()"
          [showContributorsTab]="showContributorsTab()"
          (openDetailsSidebar)="openDetailsSidebar()"
          (closeDetailsSidebar)="closeDetailsSidebar()"
          (tabChanged)="onTabChanged($event)" />
      </div>

      <lib-stepper
        [stepperId]="'request-view-stepper'"
        [options]="stepperOption()"
        class="mb-4xl"
        [isCentered]="false"
        [assigneeTemplate]="assigneeTemplate" />

      <lib-form-builder [group]="requestFormGroups()" [form]="requestForm" />

      @if (holdResumeAction().value) {
        <div
          class="my-2xl pt-2xl flex gap-xl border-t border-neutral-200 flex gap-xl justify-end">
          <lib-button
            id="request_screen_cancel_button'"
            [label]="'request_screen_cancel_button' | transloco"
            (click)="cancel()"
            [btnClass]="'px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium border border-neutral-300'" />

          <lib-button
            [id]="holdResumeAction().value"
            [label]="holdResumeAction().label"
            (click)="handleTakenAction(holdResumeAction().value)"
            [disabled]="isDisabled()"
            [btnClass]="
              'px-2xl py-sm rounded-md text-lg font-medium ' +
              (holdResumeAction().color | actionClass)
            " />
        </div>
      }
    </div>
  }
} @else {
  <lib-overlay-loader />
}

<ng-template #assigneeTemplate let-assigneeArray>
  <lib-side-menu-assignee-dropdown-view
    [userCount]="assigneeArray.length"
    [userTableList]="assigneeArray"
    [userDropdownList]="assigneeArray"
    [totalDropdownCount]="assigneeArray.length"
    [assigneeType]="assigneeArray | assigneeType"
    [headerListLabel]="'dropdown_header_list_assignees_label' | transloco"
    [searchLabel]="'dropdown_search_find_assignees_label' | transloco"
    [searchPlaceholder]="'search_by_name_placeholder' | transloco"
    [noSearchResultLabel]="'no_search_result_label' | transloco"
    [enableLocalSearch]="true"
    [imgDimensions]="{ width: 24, height: 24 }"
    [containerRef]="'request-view-stepper'" />
</ng-template>

<ng-template #holdModalTemplate>
  <lib-hold-resume-modal
    [isCommentRequired]="true"
    (closeModal)="closeModal()"
    (submitHoldResume)="holdRequest($event)" />
</ng-template>

<ng-template #resumeModalTemplate>
  <lib-hold-resume-modal
    (closeModal)="closeModal()"
    (submitHoldResume)="resumeRequest($event)" />
</ng-template>
